import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
/* import reportWebVitals from './reportWebVitals.ts'; */


function MainRender() {

  const appointments = useMemo(() => {
    return new URLSearchParams(window.location.search);
  }, [])

   

  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <MainRender />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
/* reportWebVitals(); */
